import { withWizardRefetch } from "../withWizardRefetch.js";
import {
  useProductBox_RemoveItemProductPlaceholderMutation,
  useProductBox_SetItemProductPlaceholderMutation,
  useProductSelectQuestionControlForm_ModifyWizardSettingsMutation,
} from "./ProductBox.generated.js";

export const useProductSelectQuestionControlForm_ModifyWizardSettingsMutationWithWizardRefetch =
  withWizardRefetch(
    useProductSelectQuestionControlForm_ModifyWizardSettingsMutation
  );

// Creating, retyping or removing the placeholder flips the item's product
// question, so both mutations refetch the wizard cache.
export const useProductBox_SetItemProductPlaceholderMutationWithWizardRefetch =
  withWizardRefetch(useProductBox_SetItemProductPlaceholderMutation);

export const useProductBox_RemoveItemProductPlaceholderMutationWithWizardRefetch =
  withWizardRefetch(useProductBox_RemoveItemProductPlaceholderMutation);
